module.exports = __webpack_public_path__ + "svg/trash.svg?91d823d376a1bb67fdff7d158d6cf0e0";